VjsAdmin.regexPlayground = (function () {
    const me = {};
    const districtGuid = $('.district-info').data('district-guid');
    const platform = $('.platform-info').data('platform-id');
    const init = function () {
        new PlaygroundClickEvent();
    };
    me.orgUnitHtml = '';
    me.originalRegexElement = '';

    const PlaygroundClickEvent = VjsUtility.Controller.extend({
        events: {
            'click .playground-direct-mapping': 'clickPlaygroundDirectMappingBtn',
            'click .add-to-mapping': 'clickAddRegex',
            'click .cancel-playground': 'clickCancelPlayground',
            'keyup .regex-value': 'changeRegexValue',
        },
        clickAddRegex() {
            $(me.originalRegexElement).val($('.regex-value').val());
            VjsUtility.Popup.close();
        },
        clickCancelPlayground() {
            VjsUtility.Popup.close();
        },
        clickPlaygroundDirectMappingBtn(e) {
            me.originalRegexElement = $(e.currentTarget).closest('.direct-mapping-component').find('.orgunit-name');
            const oldRegexValue = $(e.currentTarget).closest('.direct-mapping-component').find('.orgunit-name').val();
            VjsUtility.Popup.init({
                title: 'Regex Playground',
                templateUrl: '/assets/templates/google/mapping/regex-playground.html',
                after() {
                    $('.regex-value').val(oldRegexValue);
                    new PlaygroundClickEvent();
                    const orgUnitView = new PlaygroundOrgUnitView();
                    orgUnitView.fetch({
                        included_only: true,
                    });
                },
            });
        },
        changeRegexValue(e) {
            const regexValue = $(e.currentTarget).val();
            regexHighlightTest(regexValue);
        },
    });

    const PlaygroundOrgUnitView = VjsUtility.View.extend({
        parent: '.org-unit-view',
        templateUrl: '/assets/templates/google/mapping/playground-orgunit-component.html',
        dataUrl: `/platforms/${platform}/districts/${districtGuid}/google/orgunit-mapping/`,
        after() {
            me.orgUnitHtml = $('.playground-orgunit-component').html();
            const regexValue = $('.regex-value').val();
            regexHighlightTest(regexValue);
        },
    });

    function regexHighlightTest(regex) {
        let formattedString = me.orgUnitHtml;
        if (regex !== '') {
            const regexValue = regex.replace(/(\s+)/, '(<[^>]+>)*$1(<[^>]+>)*');
            const pattern = new RegExp(`(${regexValue})`, 'gi');
            formattedString = formattedString.replace(pattern, '<mark>$1</mark>');
            formattedString = formattedString.replace(/(<mark>[^<>]*)((<[^>]+>)+)([^<>]*<\/mark>)/, '$1</mark>$2<mark>$4');
        }

        $('.playground-orgunit-component').html(formattedString);
    }

    return {
        init,
    };
}());
